import { useState } from 'react';
import { tilesAPI } from '../utils/apiClient';

export const useTileOperations = () => {
  const [creating, setCreating] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);

  const createTile = async (tileData) => {
    setCreating(true);
    setError(null);
    
    try {
      const response = await tilesAPI.createTile(tileData);
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setCreating(false);
    }
  };

  const updateTile = async (id, tileData) => {
    setUpdating(true);
    setError(null);
    
    try {
      const response = await tilesAPI.updateTile(id, tileData);
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  const deleteTile = async (id) => {
    setDeleting(true);
    setError(null);
    
    try {
      const response = await tilesAPI.deleteTile(id);
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setDeleting(false);
    }
  };

  return {
    creating,
    updating,
    deleting,
    error,
    createTile,
    updateTile,
    deleteTile
  };
};